import { styles } from './CardWrapper.styles';

export interface CardWrapperProps {
  header?: React.ReactNode;
  content?: React.ReactNode;
  actionButtonText?: string;
  onActionButtonClick?: () => void;
  className?: string;
}

export function CardWrapper({
  header,
  content,
  actionButtonText,
  onActionButtonClick,
  className
}: CardWrapperProps) {
  const slots = styles();

  return (
    <div className={slots.wrapper({ className })}>
      {header}
      {content}
      {actionButtonText && (
        <div className={slots.actionButtonWrapper()}>
          <button
            type="button"
            className={slots.actionButton()}
            onClick={onActionButtonClick}
          >
            {actionButtonText}
          </button>
        </div>
      )}
    </div>
  );
}
